export default function getPixelPrefix(pixelType) {
    const pixelPrefixes = {
        'Google Tag Manager': 'GTM-',
        'Google Analytics 4': 'G-',
        'Google Ads': 'AW-',
        'Google Remarketing': 'AW-'
    };

    return pixelPrefixes[pixelType] || '';
}